import { render, staticRenderFns } from "./VueFakeInput.vue?vue&type=template&id=22f539f4&scoped=true&"
import script from "./VueFakeInput.vue?vue&type=script&lang=js&"
export * from "./VueFakeInput.vue?vue&type=script&lang=js&"
import style0 from "./VueFakeInput.vue?vue&type=style&index=0&id=22f539f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f539f4",
  null
  
)

export default component.exports